import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UiService } from 'src/app/admin/service/ui.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DirectorioService {
  url = environment.url;
  constructor(private http: HttpClient, private uiSv: UiService) {}

  getDirectives() {
    return this.http.get(`${this.url}/store/userStore`); //Obtengo todos los directorios y los guardo en el front
  }

  createDirective(data) {
    return this.http.post(`${this.url}/store/create`, data);
  }

  getGetPlanDirectives(id) {
    return this.http.get(`${this.url}/plan/show/${id}`); //Obtengo el plan correspondiente al directorio
  }

  editDirective(body) {
    return this.http.post(`${this.url}/store/edit`, body); //envio la informacion del directorio editado
  }

  certificateDirectory(data) {
    return this.http.post(`${this.url}/store/certificate`, data);
  }

  editStoreFront(data) {
    return this.http.post(`${this.url}/store/editFront`, data);
  }

  deleteImage(data) {
    return this.http.post(`${this.url}/store/deleteImages`, data);
  }

  postOrder(data) {
    return new Promise((resolve) => {
      this.http.post(`${this.url}/order/create`, data).subscribe(
        (res) => {
          resolve(res);
        },
        async (err) => {
          await this.uiSv.showToast(err.error.error);
        }
      );
    });
  }
  // bancos

  getBanks(id) {
    return this.http.get(`${this.url}/store/banks/index/${id}`);
  }
  getOrders(storeId) {
    return new Promise((resolve) => {
      const params = {
        storeId,
      };
      this.http.get(`${this.url}/order/index`, { params }).subscribe((res) => {
        resolve(res);
      });
    });
  }

  updateOrders(body) {
    return new Promise((resolve) => {
      this.http.post(`${this.url}/order/update`, body).subscribe((res) => {
        resolve(res);
      });
    });
  }

  setBank(data) {
    return this.http.post(`${this.url}/store/banks/store`, data);
  }

  editBank(data) {
    return this.http.post(`${this.url}/store/banks/update`, data);
  }

  deleteBank(data) {
    return this.http.post(`${this.url}/store/banks/delete`, data);
  }

  // get plan status

  getStatusPlan(idStore) {
    return this.http.post(`${this.url}/store/planStatus`, idStore);
  }
}
